import { Component } from 'react';

import { Flow } from 'flow-react';
import { observer } from "mobx-react";
import Login from 'Components/Login/Login';
import Page from 'Components/Page/Page';
import Forgotpw from 'Components/Forgotpw/Forgotpw';
import Register from 'Components/Register/Register';
import Tosaccept from 'Components/Tosaccept/Tosaccept';
import insertStat from 'Components/Statistic/Statistic';

const App = observer(

	class App extends Component {
		state = {errmess:'', appstate:'notloggedin', user:false, showmenleg:false, searchres:{}}
		carouselclips = []
		skchains = []
		skgenres = []
		skstatis = []
		skweeks = []
		page = 0
		fulltext = ''
		cpp = 18
		offset = 0
		skrit = {};
		isinited = false;
		critsset = false;//ob irgendwelche searchcrits gesetzt sind (dann wird kein carousel gezeigt)
		
		componentDidMount = () => {
			if(!this.isinited) {
				this.isinited = true;
				this.props.flow.init()
					.then(()=>{ 
						this.sessLogin();
					}
				);
			}
		}
		
		sessLogin = () => {
			this.props.flow.ftvfeLogin('dummy','dummy')
				.then(res=>{
					console.log(res);
					if(res.msg.user && res.msg.user.id) {
						res.msg.user.stations = res.msg.user.stations.length == 0 ? [] : res.msg.user.stations.split(',');
						res.msg.user.regstations = res.msg.user.regstations.length == 0 ? [] : res.msg.user.regstations.split(',');
						this.setState({errmess:'', appstate:'loggedin', user:res.msg.user});
						this.setCrits({});
					}
					else {
						// nix machen: state bleibt auf notloggedin, loginform wird gerendert
					}
				}).catch(e => {
						console.log(e);
						// nix machen: state bleibt auf notloggedin, loginform wird gerendert
				});
			
		}
		

			
		haveLoggedin = (data) => {
			if(data.user === false) {
				this.setState({errmess:'Error: could not log in, wrong password?', appstate:'notloggedin'});
			}
			// else if (data.user.gdpraccepted != 1) {//tosacceppt ist momentan ausgeblendet
				// data.user.stations = data.user.stations.length == 0 ? [] : data.user.stations.split(',');
				// data.user.regstations = data.user.regstations.length == 0 ? [] : data.user.regstations.split(',');
				// this.setState({errmess:'Error: Tos not yet accepted', appstate:'tosaccept', user:data.user});
			// }
			else {
			  // this.props.flow.addEventListener(felib.main.event.CLOSE,ev=>{ console.log('Socket Closed!'); });
				data.user.stations = data.user.stations.length == 0 ? [] : data.user.stations.split(',');
				data.user.regstations = data.user.regstations.length == 0 ? [] : data.user.regstations.split(',');
				// insertStat('login',data.user);
				this.setState({errmess:'', appstate:'loggedin', user:data.user});
				this.setCrits({});
			}
		}
		
		register = () => {
			this.setState({errmess:'', appstate:'register', user:false});
		}
		
		forgotPassword = () => {
			this.setState({errmess:'', appstate:'forgotpw', user:false});
		}
		
		loadLogin = () => {
			this.setState({errmess:'', appstate:'notloggedin', user:false});
		}
		
		acceptTos = () => {
			this.setState({errmess:'', appstate:'loggedin'});
			this.setCrits({});
		}
		
		setCrits = (crits) => {
			if(typeof(crits.fulltext) != 'undefined') {
				this.fulltext = crits.fulltext;
				this.props.flow.ftvfeInsertStat({'action':'fesearch','keyword':crits.fulltext});
				this.offset = 0;
			}
			if(crits.chains) {
				this.skchains = crits.chains;
				this.offset = 0;
			}
			if(crits.statis) {
				this.skstatis = crits.statis;
				this.offset = 0;
			}
			if(crits.weeks) {
				this.skweeks = crits.weeks;
				this.offset = 0;
			}
			if(crits.genres) {
				this.skgenres = crits.genres;
				this.offset = 0;
			}
			if(typeof(crits.offset) != 'undefined')
				this.offset = crits.offset;
			// if(this.offset==0 && this.skweeks==[] && this.skchains==[] && this.skstatis==[] && this.skgenres==[] && this.fulltext=='')
			if(this.skweeks.length + this.skchains.length + this.skstatis.length + this.skgenres.length + this.fulltext.length == 0)
				this.critsset = false;
			else
				this.critsset = true;
			this.skrit = {fulltext:this.fulltext,weeks:this.skweeks,chains:this.skchains,genres:this.skgenres,statis:this.skstatis,offset:this.offset,limit:this.cpp};
			this.doSliderSearch();
		}
		
		
		
		doSliderSearch = () => {
			if(this.carouselclips.length < 1) {
				this.props.flow.ftvfeSearch({statis:[],chains:[],genres:[],weeks:[],fulltext:'','txt20':'yes'})
					.then(res=>{this.parseSliderSearchres(res)})
			}
			else {
				this.doSearch();
			}
		}
		
		
		parseSliderSearchres = (res) => {
			if(res.clip) {
				// this.clips = res.objects.asArray();
				res.message = 'success';
				this.carouselclips = [];
				for(var cl of res.objects.asArray()) {
					if(cl.getMetadata().get('txt20') == 'yes') {
						let url = false;
						for(var mf of cl.getMediafiles().elements) {
							let tags = mf.getTags() || '';
							// console.log(tags);
							if(!url && tags.indexOf('slider') > -1) { 
								url = 'https://www.francetvpreview.fr/mfc/thumbnail.cgi?file='+mf.getPath()+mf.getFilename()+'&crop_inner_height=345&crop_inner_width=1000&cache=1';
								// url = 'https://francetv.demo.flowcenter.de/mfc/thumbnail.cgi?file='+mf.getPath()+mf.getFilename()+'&crop_inner_height=345&crop_inner_width=1000&cache=1';
							}
						}
						if(!url && !!cl.getMainthumbnail()) 
							url = 'https://www.francetvpreview.fr/mfc/thumbnail.cgi?file='+cl.getMainthumbnail().getFilename()+'&crop_inner_height=345&crop_inner_width=1000&cache=1';
							// url = 'https://francetv.demo.flowcenter.de/mfc/thumbnail.cgi?file='+cl.getMainthumbnail().getFilename()+'&crop_inner_height=345&crop_inner_width=1000&cache=1';
						if(url) {
							let subtitle = cl.getMetadata().get('txt23');
							if(typeof(subtitle) != 'string') subtitle = '';
							let chains = cl.getMetadata().get('txt3');
							if(typeof(chains) != 'string') chains = '';
							this.carouselclips.push({'clip':cl,'clid':cl.getId(),'title':cl.getTitle(),'chains':chains,'subtitle':subtitle,'url':url});
						}
					}
				}
			}
			this.doSearch();
		}
		
		doSearch = () => {
			this.props.flow.ftvfeSearch(this.skrit)
      .then(res=>{this.parseSearchres(res)})
		}
		
		parseSearchres = (res) => {
			if(res.clip) {
				// this.clips = res.objects.asArray();
				res.message = 'success';
				// this.carouselclips = [];
				// for(var cl of res.objects.asArray()) {
					// if(cl.getMetadata().get('txt20') == 'yes' && !this.critsset) {
						// let url = false;
						// for(var mf of cl.getMediafiles().elements) {
							// let tags = mf.getTags() || '';
							// console.log(tags);
							// if(!url && tags.indexOf('slider') > -1) { 
								// url = 'https://francetv.flowcenter.de/mfc/thumbnail.cgi?file='+mf.getPath()+mf.getFilename()+'&crop_inner_height=187&crop_inner_width=823&cache=1';
							// }
						// }
						// if(!url && !!cl.getMainthumbnail()) 
							// url = 'https://francetv.flowcenter.de/mfc/thumbnail.cgi?file='+cl.getMainthumbnail().getFilename()+'&crop_inner_height=187&crop_inner_width=823&cache=1';
						// if(url)
							// this.carouselclips.push({'clid':cl.getId(),'title':cl.getTitle(),'url':url});
					// }
				// }
			}
			else {
				res.message = 'error';
			}
			this.setState({searchres:res,showmenleg:false});
		}
		
		updateUser = (u) => {
			u.stations = u.stations.split(',');
			u.regstations = u.regstations.split(',');
			this.setState({user:u});
		}
		
		
		openMentionslegal = () => {
			this.setState({showmenleg:true});
		}
		
		
		render() {
			let loadprofile = (!!this.props.deletelink);
			if(this.state.appstate == 'loggedin') {
				return (
					<Page user={this.state.user} 
								critsset={this.critsset} 
								showmenleg= {this.state.showmenleg}
								skchains={this.skchains} 
								skgenres={this.skgenres} 
								skweeks={this.skweeks} 
								skstatis={this.skstatis} 
								searchres = {this.state.searchres}
								setcritcb = {this.setCrits}
								showmenlegcb = {this.openMentionslegal}
								updusercb = {this.updateUser}
								fulltextterm = {this.fulltext}
								carouselclips = {this.critsset ? [] : this.carouselclips}
								loadprofile = {!!this.props.deletelink}
					/>
				);
			}
			else if(this.state.appstate == 'notloggedin') {
				return (
					<Login logincb={this.haveLoggedin} registercb={this.register} pwforgotcb={this.forgotPassword}/>
				);
			}
			else if(this.state.appstate == 'forgotpw') {
				return (
					<Forgotpw logincb={this.loadLogin}/>
				);
			}
			else if(this.state.appstate == 'register') {
				return (
					<Register logincb={this.loadLogin}/>
				);
			}
			else if(this.state.appstate == 'tosaccept') {
				return (
					<Tosaccept accepttoscb={this.acceptTos}/>
				);
			}
			
		}
	}

)


export default Flow.injectFlow(App);